import React, { memo, useEffect, useState } from "react";
import { validators } from "investira.sdk";
import {
  Stack,
  CircularProgress,
  Typography,
  Divider,
} from "investira.react.components";
import withResponseHandling from "../../../hoc/withResponseHandling";
import SearchGlobalItem from "./SearchGlobalItem";
import SearchGlobalFilter from "./SearchGlobalFilter";

const SearchGlobalResultado = memo((props) => {
  const { isLoading, data, message, onClick } = props;

  const [filter, setFilter] = useState({ pesquisa_origem: null });
  const [resultado, setResultado] = useState(null);

  // Função para filtrar o array de dados conforme os filtros passados
  function filtrarData(pData = [], pFiltros = {}) {
    // Se não houver pFiltros, retorna o array original
    if (
      !pFiltros ||
      Object.keys(pFiltros).length === 0 ||
      pFiltros.pesquisa_origem == null
    ) {
      return pData;
    }

    // Filtra o array pData conforme os filtros
    return pData.filter((item) => {
      // Para cada filtro, verifica se o item corresponde ao valor do filtro
      return Object.entries(pFiltros).every(([chave, valor]) => {
        // Se o valor do filtro for undefined, null ou string vazia, ignora o filtro
        if (valor === undefined || valor === null || valor === "") {
          return true;
        }
        // Se o item não possuir a chave, retorna false
        if (!(chave in item)) {
          return false;
        }
        // Caso especial para "pessoa_tipo", que é um array, mas o filtro é valor único
        if (chave === "pessoa_tipo" && Array.isArray(item[chave])) {
          return item[chave].includes(valor);
        }
        // Comparação simples para os demais casos
        return item[chave] === valor;
      });
    });
  }

  useEffect(() => {
    setFilter({});
  }, [data]);

  useEffect(() => {
    if (!validators.isEmpty(data)) {
      const xResultado = filtrarData(data, filter);
      setResultado(xResultado);
    }
  }, [data, filter]);

  return (
    <>
      <Stack>
        {!isLoading &&
          !validators.isEmpty(data) &&
          !validators.isEmpty(resultado) && (
            <>
              <SearchGlobalFilter
                filter={filter}
                setFilter={setFilter}
                data={data}
              />
              <Divider sx={{ mb: 1 }} />

              <>
                <Stack id={`busca-list`} sx={{ px: 0 }} component="ul">
                  {Array.isArray(resultado) &&
                    resultado.map((xItem) => (
                      <SearchGlobalItem
                        key={crypto.randomUUID()}
                        data={xItem}
                        onClick={(e) => onClick(e, xItem, props.clearOnClose)}
                      />
                    ))}
                </Stack>

                {/* {filter?.pesquisa_origem !== "indicador" &&
                  !validators.isNull(filter?.pesquisa_origem) && (
                    <Stack
                      sx={{
                        px: 2,
                        py: 2,
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() =>
                          onSearch(filter.pesquisa_origem, filter.mercado)
                        }
                        sx={{ maxWidth: "500px", px: 4 }}
                      >
                        Visualizar Todos
                      </Button>
                    </Stack>
                  )} */}
              </>
            </>
          )}

        {isLoading && (
          <Stack
            justifyContent="center"
            alignItems="center"
            flexGrow={1}
            sx={{ py: 2 }}
          >
            <CircularProgress size={24} />
          </Stack>
        )}

        {!isLoading && validators.isEmpty(data) && (
          <Stack
            justifyContent="center"
            alignItems="center"
            flexGrow={1}
            sx={{ py: 2 }}
          >
            <Typography variant="body2" color="textPrimary">
              {message}
            </Typography>
          </Stack>
        )}
      </Stack>
    </>
  );
});

export default withResponseHandling(SearchGlobalResultado);
